import {Landmark, FileText, Shield, TrendingUp, MapPin, Scale} from 'lucide-react'

const features = [
  {
    icon: Landmark,
    title: "Land Contract Balloon Payment Calculator",
    description:
      "Land contracts frequently include balloon payments — a large lump sum due at a specific point in the loan. Our land financing calculator helps you understand exactly when that balloon payment hits and how much you will owe. Plan ahead for refinancing or savings to cover this critical milestone in your land contract.",
  },
  {
    icon: FileText,
    title: "Amortization Schedule for Land Contracts",
    description:
      "Unlike traditional residential mortgages, land loan interest is often calculated differently. Our amortization tool generates a complete month-by-month breakdown showing exactly how each payment splits between principal and interest. This land payment estimator gives you full transparency into your raw land mortgage or hunting land mortgage.",
  },
  {
    icon: Shield,
    title: "Land Equity Calculator",
    description:
      "Track your equity growth over time with our land equity calculator. See how your down payment, monthly payments, and extra contributions build ownership in your property. Essential for understanding your investment position in any land note or contract.",
  },
  {
    icon: TrendingUp,
    title: "Extra Payment Impact Analysis",
    description:
      "Discover how even small extra monthly payments can dramatically reduce your total interest and shorten your loan term. Our calculator shows the real dollar impact of additional contributions on your land financing, helping you make informed decisions about accelerating your payoff.",
  },
  {
    icon: MapPin,
    title: "Raw Land & Hunting Land Financing",
    description:
      "Whether you are financing raw land for development or a hunting land mortgage for recreational use, our calculator handles all scenarios. Land loans typically carry higher interest rates than residential mortgages — our tool helps you compare options and find the best financing strategy.",
  },
  {
    icon: Scale,
    title: "Land Note Calculator",
    description:
      "Evaluate land notes with precision. Our land note calculator helps both buyers and sellers understand the true cost and value of owner-financed land deals. Compare different terms, rates, and down payment scenarios to negotiate the best deal.",
  },
]

export default function FeatureSection() {
  return (
    <section className="py-20 bg-white" id="features">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-emerald-50 text-emerald-800 rounded-full text-sm font-semibold mb-4 border border-emerald-200">
            Comprehensive Tools
          </span>
          <h2
            className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'DM Serif Display', serif" }}
          >
            Specialized Land Financing & Amortization Calculator
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg">
            Everything you need to understand and plan your land purchase financing. From balloon payments to equity tracking, our tools cover every aspect of land contracts.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <article
              key={feature.title}
              className="group bg-white rounded-2xl p-6 border-2 border-gray-100 hover:border-emerald-200 hover:shadow-lg transition-all duration-300"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-12 h-12 bg-emerald-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-emerald-100 transition-colors">
                <feature.icon className="w-6 h-6 text-emerald-700" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" style={{ fontFamily: "'DM Serif Display', serif" }}>
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
